class TableState {

    constructor() {
        this.page = 1;
        this.pageSize = 50;
        this.count = 0;
    }

    static getSearchOp() {
        return '##'
    }

    static getFilterOp() {
        return '=='
    }

    static fromRaw(raw) {
        let tableState = new TableState();
        let searchOp = TableState.getSearchOp();
        tableState.count = raw.totalEntityCount; // TODO entityCount when fixed
        tableState.countTotal = raw.grandTotalEntityCount;
        tableState.page = raw.pagination ? raw.pagination.pageNumber : null;
        tableState.pageSize = raw.pagination ? raw.pagination.pageSize : null;
        tableState.tableStatename = raw.tableStatename;
        tableState.orderBy = raw.orderBy;
        tableState.filter = raw.filters;
        if (tableState.filter[0]) {
            // tableState.filter = tableState.filter[0].split(' AND ')[0];
            tableState.searchKey = tableState.filter[0].fieldName[0];
            tableState.searchBy = tableState.filter[0].filterValues[0];
        }
        return tableState;
    }
}

module.exports = TableState;


// WEBPACK FOOTER //
// ./src/azurebackup/model/TableState.js